<aura-edit-wrapper
  title="Coordonnées professionnelles"
  [(isEditing)]="isEditing"
  [isAllowedToEdit]="isAllowedToEdit()"
  [showDivider]="true"
  (saved)="onSave($event)"
  #editWrapper="auraEditWrapper"
>
  @if (editWrapper.isEditing()) {
    <etxe-agent-contact-infos-form
      [contactInfos]="currentContactInfos()"
      (validityChanged)="editWrapper.onValidityChanged($event)"
      (dtoChanged)="editWrapper.onDtoChanged($event)"
    />
  } @else {
    <etxe-agent-contact-infos-display [contactInfos]="currentContactInfos()" />
  }
</aura-edit-wrapper>
